import { configureStore } from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage'
import { combineReducers } from "redux";
import { persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';
import appReducer from './app/reducer';
import transactionReducer from './transaction/reducer';

/// <summary>
/// Author: -
/// </summary>
const store = configureStore({
    reducer: {
        appState: appReducer,
        transactionState: transactionReducer,
    },
    middleware: [thunk]
});

export default store;